"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUnderscore = function (str) {
    return str
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase();
};
exports.spaceToPlus = function (str) { return str.split(/\s/).join('+'); };
//# sourceMappingURL=stringUtils.js.map